import { EpiBlock, EpiContent } from '@api/types';
import { BlockContainer, Title } from '@components';
import FormRenderingService from '@components/features/Forms/FormRenderingService';
import { Box } from '@mui/material';
import React, { useEffect, useMemo } from 'react';

/**
 * Form Container Props.
 * Maps to FormContainerBlock from EPI
 */
export type FormContainerBlockProps = EpiBlock & {
  children?: React.ReactNode;
  elementsArea?: EpiContent;
  submitSuccessMessage?: string;
  redirectToPage?: string;
  formModel?: FormModel;
};

/**
 * Form Model from API
 */
export type FormModel = {
  template?: string;
  assets?: FormModelAssets;
};

export type FormModelAssets = {
  css?: string;
  jquery?: string;
  originalJquery?: string;
  prerequisite?: string;
  viewModeJs?: string;
};

/**
 * Form Container Block.
 * Used to display FormContainerBlock from EPI
 */
export const FormContainerBlock = ({
  formModel = {},
  contentLink,
  ...props
}: FormContainerBlockProps) => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const formId = useMemo(() => 'form-html-' + contentLink?.id + new Date().getTime(), []);

  useEffect(() => {
    const formElement = document.querySelector('#' + formId);
    FormRenderingService.render(formModel, formElement);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!formModel?.assets || !formModel?.template) {
    return null;
  }
  return (
    <BlockContainer>
      <Box sx={{ textAlign: 'center' }}>
        <Title sx={{ mb: 2 }}>{props.name}</Title>
        <Box id={formId}></Box>
      </Box>
    </BlockContainer>
  );
};
